const { overlaps, getPieceSize } = require('@/helpers/utils.js');
const { PIECES } = require("@/helpers/pieces.js");
const { GRID_SIZE } = require("@/helpers/board-constants.js");
const { to1d, to2d } = require("@/helpers/utils.js");
const { range } = require("./utils/array.js");

function inBounds (x, y) {
  return x >= 0 && y >= 0 && x < GRID_SIZE && y < GRID_SIZE;
}

function checkFullRowsAndColumns (grid) {
  const full = { rows: [], cols: [] };
  for (let row = 0; row < GRID_SIZE; row++) {
    if(range(GRID_SIZE, row * GRID_SIZE).every((i) => grid[i] !== null)) {
      full.rows.push(row);
    }
  }
  for (let col = 0; col < GRID_SIZE; col++) {
    if(range(GRID_SIZE).every((i) => grid[to1d(col, i)] !== null)) {
      full.cols.push(col);
    }
  }
  return full;
}

function checkHasSpace (grid, emptyCells, deck) {
  let cells, pieceIsOk, totalOk;
  totalOk = 0;
  for (let piece of deck) {
    pieceIsOk = false;
    cells = PIECES[piece.ref].cells;
    const { w, h } = getPieceSize(cells);
    const hw = Math.round(w / 2);
    const hh = Math.round(h / 2);
    for (let cell of emptyCells) {
      const { x, y } = to2d(cell);
      for (let i = -hw; i <= hw; i++) {
        for (let j = -hh; j <= hh; j++) {
          if (!overlaps(grid, cells, x + i, y + j)) {
            pieceIsOk = true;
            break;
          }
          if (pieceIsOk) { break; }
        }
        if (pieceIsOk) { break; }
      }
      if (pieceIsOk) { break; }
    }
    if (pieceIsOk) {
      totalOk++;
    }
  }
  return totalOk > 0;
}

module.exports = {
  inBounds,
  checkFullRowsAndColumns,
  checkHasSpace
};
